import {Params} from '@feathersjs/feathers'

import {Carrier} from '../../types'

import * as feathersService from '../feathers'

export const RESOURCE = 'carrier'

export const get = async (params?: Params) => feathersService.find<Carrier>(RESOURCE, params)
